import { User } from '@biniyog/models';
import React from 'react';

export interface IAuth {
  user: Partial<User> | undefined;
  access_token: string | undefined;
  isRememberMe?: boolean;
  authError?: any;
  setUser?: (user: Partial<User>) => void;
  setAccessToken?: (token: string) => void;
  setIsRememberMe?: (value: boolean) => void;
  setAuthError?: (value: any) => void;
}

export const AuthContext = React.createContext<IAuth>({
  user: undefined,
  access_token: undefined,
  isRememberMe: false,
});
